import { navLinks, contactPhone, trustCompany, trustCompanyEn, bankInfo, totalUnits } from '@/mocks/homeData';

export default function Footer() {
  const handleNavClick = (href: string) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="relative w-full bg-background-100 border-t border-background-200/50">
      <div className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16 max-w-6xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          <div>
            <h4 className="text-base font-semibold text-foreground-900 mb-4">분양안내</h4>
            <ul className="space-y-2.5">
              <li>
                <a href="#about" onClick={(e) => { e.preventDefault(); handleNavClick('#about'); }} className="text-base text-foreground-600 hover:text-foreground-900 transition-colors">
                  단지 소개
                </a>
              </li>
              <li>
                <a href="#community" onClick={(e) => { e.preventDefault(); handleNavClick('#community'); }} className="text-base text-foreground-600 hover:text-foreground-900 transition-colors">
                  입지 프리미엄
                </a>
              </li>
              <li>
                <a href="#units" onClick={(e) => { e.preventDefault(); handleNavClick('#units'); }} className="text-base text-foreground-600 hover:text-foreground-900 transition-colors">
                  세대 정보
                </a>
              </li>
              <li>
                <a href="#pricing" onClick={(e) => { e.preventDefault(); handleNavClick('#pricing'); }} className="text-base text-foreground-600 hover:text-foreground-900 transition-colors">
                  분양가 안내
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="text-base font-semibold text-foreground-900 mb-4">세대정보</h4>
            <ul className="space-y-2.5">
              <li><span className="text-base text-foreground-600">59㎡ 타입 (315세대)</span></li>
              <li><span className="text-base text-foreground-600">71㎡ 타입 (37세대)</span></li>
              <li><span className="text-base text-foreground-600">84㎡ 타입 (107세대)</span></li>
            </ul>
          </div>
          <div>
            <h4 className="text-base font-semibold text-foreground-900 mb-4">계약안내</h4>
            <ul className="space-y-2.5">
              <li><span className="text-base text-foreground-600">장기일반민간임대주택</span></li>
              <li><span className="text-base text-foreground-600">HUG 전세자금대출 80%</span></li>
              <li><span className="text-base text-foreground-600">10년 거주 후 소유권 이전</span></li>
            </ul>
          </div>
          <div>
            <h4 className="text-base font-semibold text-foreground-900 mb-4">고객센터</h4>
            <ul className="space-y-2.5">
              <li>
                <a href={`tel:${contactPhone}`} className="text-base text-foreground-600 hover:text-foreground-900 transition-colors">
                  전화상담 {contactPhone}
                </a>
              </li>
              <li>
                <a href="#reservation" onClick={(e) => { e.preventDefault(); handleNavClick('#reservation'); }} className="text-base text-foreground-600 hover:text-foreground-900 transition-colors">
                  방문예약 신청
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-200/50 pt-10 md:pt-14">
          <div className="flex flex-col lg:flex-row items-start justify-between gap-10 lg:gap-16">
            {/* 왼쪽: 로고 + 브랜드명 + 슬로건 */}
            <div className="flex flex-col items-start">
              {/* 로고 원형 배지 */}
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-background-50 border border-background-200 flex items-center justify-center mb-5">
                <span className="font-heading text-xs md:text-sm font-bold text-primary-600 tracking-tight">
                  iaan
                </span>
              </div>
              <h3 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 tracking-tight mb-1">
                신상도역 이안
              </h3>
              <p className="text-xs md:text-sm font-medium text-foreground-500 tracking-[0.2em] uppercase mb-4">
                Sinsangdo Station Ian
              </p>
              <p className="text-base text-foreground-600 leading-relaxed max-w-sm">
                도심 속 자연을 품은 상도동의 새로운 기준. 신상도역 이안이 당신의 삶에 프리미엄 라이프를 선사합니다.
              </p>
            </div>

            {/* 오른쪽: SITE INFORMATION */}
            <div className="w-full lg:w-auto">
              <p className="text-xs md:text-sm font-semibold text-foreground-500 tracking-[0.25em] uppercase mb-5">
                Site Information
              </p>
              <div className="grid grid-cols-[auto_1fr] gap-x-6 gap-y-3 text-base">
                <span className="text-foreground-500 whitespace-nowrap">현장명</span>
                <span className="text-foreground-900 font-medium">신상도역 이안</span>

                <span className="text-foreground-500 whitespace-nowrap">현장주소</span>
                <span className="text-foreground-900 font-medium">서울특별시 동작구 상도동 211-386번지 일원</span>

                <span className="text-foreground-500 whitespace-nowrap">관리자</span>
                <span className="text-foreground-900 font-medium">(주)애드탱크</span>

                <span className="text-foreground-500 whitespace-nowrap">담당자</span>
                <a href="tel:010-4601-8729" className="text-foreground-900 font-medium hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">010-4601-8729</a>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/30 flex items-center justify-center">
          <span className="text-sm text-foreground-400">
            본 사이트의 내용은 참고용이며 실제 분양 조건과 상이 할 수 있습니다.
          </span>
        </div>
      </div>
    </footer>
  );
}